import React, { useState, useEffect } from 'react';
import { API } from '../services/api';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import './CurrentStock.css';

function CurrentStock({ store }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    API.getCurrentStock()
      .then(stockData => {
        let filtered = stockData;
        if (store) {
          filtered = stockData.filter(item => item.store_code === store);
        }
        setData(filtered);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [store]);

  if (loading) return <div className="component-loading">Loading current stock...</div>;
  if (error) return <div className="component-error">Error: {error}</div>;

  const outOfStock = data.filter(item => item.status === 'OUT_OF_STOCK');
  const inStock = data.filter(item => item.status === 'IN_STOCK');
  const outOfStockCount = outOfStock.length;
  const totalCount = data.length;
  const outOfStockPercent = totalCount > 0 ? ((outOfStockCount / totalCount) * 100).toFixed(1) : 0;

  return (
    <div className="current-stock">
      <h2>Current Stock Status</h2>
      
      <div className="stock-summary">
        <div className="summary-card">
          <div className="summary-label">Total Items</div>
          <div className="summary-value">{totalCount}</div>
        </div>
        <div className="summary-card warning">
          <div className="summary-label">Out of Stock</div>
          <div className="summary-value">{outOfStockCount}</div>
        </div>
        <div className="summary-card success">
          <div className="summary-label">In Stock</div>
          <div className="summary-value">{inStock.length}</div>
        </div>
        {/* <div className="summary-card">
          <div className="summary-label">Out of Stock %</div>
          <div className="summary-value">{outOfStockPercent}%</div>
        </div> */}
      </div>

      {outOfStockCount > 0 && (
        <div className="out-of-stock-list">
          <h3>Out of Stock Items</h3>
          <div className="stock-table">
            <table>
              <thead>
                <tr>
                  <th>Store</th>
                  <th>Item</th>
                  <th>Last Checked</th>
                </tr>
              </thead>
              <tbody>
                {outOfStock.map((item, idx) => {
                  // Convert UTC time from database to PST
                  let formattedTime = 'N/A';
                  
                  if (item.last_checked) {
                    try {
                      // Database stores UTC time as "2025-12-09 22:30:24"
                      // Convert to ISO format and mark as UTC
                      let dateString = String(item.last_checked).trim();
                      if (dateString.includes(' ')) {
                        dateString = dateString.replace(' ', 'T') + 'Z';
                      }
                      
                      // Parse as UTC and convert to PST
                      const utcDate = new Date(dateString);
                      const pstTime = utcToZonedTime(utcDate, 'America/Los_Angeles');
                      // Subtract 8 hours from the time
                      pstTime.setHours(pstTime.getHours());
                      formattedTime = format(pstTime, 'MMM d, yyyy h:mm:ss a') + ' PST';
                    } catch (error) {
                      formattedTime = String(item.last_checked || 'N/A');
                    }
                  }

                  return (
                    <tr key={idx}>
                      <td>{item.store_code}</td>
                      <td>{item.item_name || item.item_id}</td>
                      <td>{formattedTime}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {outOfStockCount === 0 && (
        <div className="all-in-stock">
          ✅ All items are in stock!
        </div>
      )}
    </div>
  );
}

export default CurrentStock;

